import React, { useState } from 'react';
import EventInstanceList from './EventInstanceList';
import EventTemplateList from './EventTemplateList';
import './EventsGroupBookingsCard.css';

type TabType = 'instances' | 'templates';

const EventsGroupBookingsCard: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState<TabType>('instances');

  return (
    <div className="config-card events-card">
      <div
        className="config-card-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="config-card-title">
          <span className="config-card-icon">📅</span>
          <h2>Events & Group Bookings</h2>
        </div>
        <span className={`config-card-toggle ${isExpanded ? 'expanded' : ''}`}>
          ▼
        </span>
      </div>

      {isExpanded && (
        <div className="config-card-content">
          <div className="events-tabs">
            <button
              className={activeTab === 'instances' ? 'active' : ''}
              onClick={(e) => {
                e.stopPropagation();
                setActiveTab('instances');
              }}
            >
              Upcoming Events
            </button>
            <button
              className={activeTab === 'templates' ? 'active' : ''}
              onClick={(e) => {
                e.stopPropagation();
                setActiveTab('templates');
              }}
            >
              Event Templates
            </button>
          </div>

          <div className="events-tab-content">
            {activeTab === 'instances' && <EventInstanceList />}
            {activeTab === 'templates' && <EventTemplateList />}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventsGroupBookingsCard;
